import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4e45bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tx-loading" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"tx-animate\" data-v-f4e45bfa><div class=\"chain-countdown-animation\" data-v-f4e45bfa><div class=\"animation-ball\" data-v-f4e45bfa><div class=\"animation-ball-num font-bold\" data-v-f4e45bfa><div class=\"left-num-animation\" data-v-f4e45bfa><span data-v-f4e45bfa>11011000101010110001010101</span></div><div class=\"center-num-animation\" data-v-f4e45bfa><div class=\"center-num\" data-v-f4e45bfa><span data-v-f4e45bfa>11011000101010110001010101</span></div></div><div class=\"right-num-animation\" data-v-f4e45bfa><span data-v-f4e45bfa>11011000101010110001010101</span></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "timing" }
const _hoisted_4 = { class: "wait-info" }
const _hoisted_5 = { class: "text-opacity" }
const _hoisted_6 = { class: "chain-symbol" }
const _hoisted_7 = { class: "text-opacity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!
  const _component_chain_tag = _resolveComponent("chain-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_greeting_card, { greetings: _ctx.title }, null, 8, ["greetings"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$tools.numFillZero(_ctx.timing.minu)) + ":" + _toDisplayString(_ctx.$tools.numFillZero(_ctx.timing.second)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("wait")), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$checkI18n("redPackFrom", {
            address: _ctx.$tools.captureAddress(_ctx.from),
          })), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$checkI18n("redPackName", { symbol: _ctx.tokenName })), 1),
        _createVNode(_component_chain_tag, { chainId: _ctx.chainId }, null, 8, ["chainId"])
      ])
    ])
  ]))
}